import React, { useState } from 'react';
import { Button } from 'reactstrap';
import CodeMirror from '@uiw/react-codemirror';
import { css } from '@codemirror/lang-css';
import { html } from '@codemirror/lang-html';
import { json } from '@codemirror/lang-json';
import prettier from 'prettier/standalone';
import * as parserHtml from 'prettier/parser-html';
import * as parserPostcss from 'prettier/parser-postcss';

export const AccentCodeEditor = ({
    language = 'css',
    defaultValue = '',
    onChange,
    onEditorCreated,
    height = '100%',
    width = '800px',
    onContextMenu,
    onFocus
}) => {
    const [code, setCode] = useState(defaultValue);

    // Map language string to the appropriate language extension
    const getLanguageExtension = (lang) => {
        switch (lang.toLowerCase()) {
            case 'css':
                return css();
            case 'html':
                return html();
            case 'json':
                return json();
            default:
                throw new Error("Not supported language");
        }
    };

    // Handle editor change
    const handleChange = (value) => {
        setCode(value);
        if (onChange) onChange(value);
    };

    // Format code using Prettier
    const formatCode = async () => {
        try {
            const codeString = typeof code === 'string' ? code : String(code);
            let formatted;

            

            if (language.toLowerCase() === 'html') {
                formatted = await prettier.format(codeString, {
                    parser: "html",
                    plugins: [parserHtml]
                });
            } else if (language.toLowerCase() === 'css') {
                formatted = await prettier.format(codeString, {
                    parser: "css",
                    plugins: [parserPostcss]
                });
            }
            setCode(formatted);
        } catch (e) {
            console.error('Error formatting code', e);
        }
    };



    return (
        <div
            className="accent-code-editor"
            style={{
                width,
                height,
                border: '1px solid #ddd',
                borderRadius: '4px',
                overflow: 'auto'
            }}
            onContextMenu={onContextMenu}
            onFocus={onFocus}
        >
            <Button color="primary" onClick={formatCode} style={{ margin: '10px' }}>
                Format Code
            </Button>
            <CodeMirror
                value={code}
                height={height}
                width={width}
                theme="dark"
                extensions={[getLanguageExtension(language)]}
                onChange={handleChange}
                onCreateEditor={(view) => {
                    if (onEditorCreated) onEditorCreated(view);
                }}
                basicSetup={{
                    lineNumbers: true,
                    highlightActiveLine: true,
                    highlightSelectionMatches: true,
                    autocompletion: true,
                    foldGutter: true,
                    dropCursor: true,
                    allowMultipleSelections: true,
                    indentOnInput: true,
                    bracketMatching: true,
                    closeBrackets: true
                }}
            />
        </div>
    );
};

export default AccentCodeEditor;
